module.exports = __webpack_public_path__ + "img/card-serviceplaces-hover.3b268699.svg";